/* eslint-disable jsx-a11y/interactive-supports-focus */
import React, { useState, useEffect } from 'react';
import { Box, IconButton, Link } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import FilterListIcon from '@material-ui/icons/FilterList';
import AutocompleteWrapper from '../../components/common/Autocomplete/AutocompleteWrapper';

import { useFetchOrgUnitOptions, useFetchClinicianOptionsForUser } from '../../actions/areas/shared/fetchOptions';
import KeyboardDateSelector from '../../components/common/KeyboardDateTimeSelectors/KeyboardDateSelector';
import { isDateFromBeforeDateTo, isValidDate } from '../../utils/dates';

const defaultState = {
  selectedOrgUnits: [],
  selectedClinicians: [],
  dateFrom: null,
  dateTo: null,
  reloadCliniciansData: false,
  retrieveOnlyActive: true,
};

const style = {
  maxHeight: '30px',
};

export default function NPASearchFilters({ onSubmit, events }) {
  const [state, setState] = useState(defaultState);

  const locale = events.locale;

  const clinicianOptionsModel = {
    teamIds: state.selectedOrgUnits.map(x => x.id),
    RetrieveOnlyActive: state.retrieveOnlyActive,
  };

  const { data: teamsOptions } = useFetchOrgUnitOptions(false);
  const { data: clinicianOptions } = useFetchClinicianOptionsForUser(clinicianOptionsModel, state.reloadCliniciansData);

  const handleSave = () => {
    onSubmit(state);
  };

  const handleClear = () => {
    setState(defaultState);
    onSubmit(defaultState);
  };

  const filterSelectedClinicians = () => {
    return state.selectedClinicians.filter(item => clinicianOptions.find(i => i.id === item.id));
  };

  const selectedClinicians = filterSelectedClinicians();

  useEffect(() => {
    setState({
      ...state,
      selectedClinicians: filterSelectedClinicians(),
    });
  }, [state.selectedClinicians.length !== selectedClinicians.length]);

  const onChangeDropDown = (key, values) => {
    if (key === 'selectedOrgUnits') {
      setState({
        ...state,
        [key]: values,
        selectedClinicians,
        reloadCliniciansData: !state.reloadCliniciansData,
      });
    } else {
      setState({
        ...state,
        [key]: values,
      });
    }
  };

  const areDatesValid =
    isValidDate(state.dateFrom, true) &&
    isValidDate(state.dateTo, true) &&
    isDateFromBeforeDateTo(state.dateFrom, state.dateTo, true);

  return (
    <section className="slick-page-header-section">
      <Box className="filter-section" display="flex" flexWrap="nowrap" p={0} justifyContent="flex-start" px={1}>
        <Box p={1}>
          <FilterListIcon />
        </Box>
        <Box p={1} width={80} textAlign="end">
          <span>Org Units</span>
        </Box>
        <Box p={1} width={200} flexGrow={1}>
          <AutocompleteWrapper
            fieldKey="selectedOrgUnits"
            data={teamsOptions}
            isMultiple
            defaultValue={state.selectedOrgUnits}
            fullWidth
            limitTags={2}
            onChange={onChangeDropDown}
            isCheckbox
            style={style}
            size="small"
          />
        </Box>
        <Box p={1} width={80} textAlign="end">
          <span>{locale.getMsg('clinicians')}</span>
        </Box>
        <Box p={1} width={200} flexGrow={1}>
          <AutocompleteWrapper
            fieldKey="selectedClinicians"
            data={clinicianOptions}
            isMultiple
            fullWidth
            limitTags={2}
            isCheckbox
            onChange={onChangeDropDown}
            defaultValue={selectedClinicians}
            style={style}
            size="small"
          />
        </Box>
        <Box p={1} width={80} textAlign="end">
          <span>{locale.getMsg('dateFrom')}</span>
        </Box>
        <KeyboardDateSelector
          id="date-picker-inline-from"
          value={state.dateFrom}
          onChange={date => setState({ ...state, dateFrom: date })}
          className="calendar-picker-input"
          maxDate={state.dateTo || undefined}
          maxDateMessage=""
          disableToolbar
        />
        <Box p={1} width={80} textAlign="end">
          <span>{locale.getMsg('dateTo')}</span>
        </Box>
        <KeyboardDateSelector
          id="date-picker-inline-from"
          value={state.dateTo}
          onChange={date => setState({ ...state, dateTo: date })}
          className="calendar-picker-input"
          minDate={state.dateFrom || undefined}
          minDateMessage={locale.getMsg('dateToBeforeDateFrom')}
          disableToolbar
        />
        <Box p={1} width={20} />
        <Box p={1}>
          <Link className="cancel-link" onClick={handleClear}>
            Clear
          </Link>
        </Box>
        <Box p={1}>
          <IconButton type="submit" size="small" className="search-icon" onClick={handleSave} disabled={!areDatesValid}>
            <SearchIcon />
          </IconButton>
        </Box>
      </Box>
    </section>
  );
}
